// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3Z_Sb","infoBtn":"quickbooks_infoBtn__3Veu8","formBox":"quickbooks_formBox__UZqiV","formFooter":"quickbooks_formFooter__18Lxx"};